


































































import Calender from '@/views/atoms/Calender.vue'
import moment from 'moment'
import Global from '@/common/global.js'
import SearchYear from '@/views/organisms/SearchYear.vue'
import PopupGasMeterEdit from '@/views/template/PopupGasMeterEdit.vue'
import store from '@/store'
import ApiClient from '@/common/api'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    Calender
    SearchYear
    PopupGasMeterEdit
    PopupComplete
  }

  data: () ->
    collectList: []
    gasMeterList: []
    gasMeter: ''
    dateTime: ''
    isShowPopup: {}
    id: ''
    user_id: ''
    gas_meter_id: ''
    year: ''
    month: ''
    complete: ''

  created: () ->
    store.dispatch('initPostParam')
    date = new Date();
    @year = date.getFullYear()
    @getCollect(@year)

  methods: {
    yearSearch: (e) ->
      @year = e.year
      @getCollect(e.year)
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    clickCell: (id, gasMeter, dateTime, user_id, gas_meter_id, k) ->
      @id = id
      @gasMeter = gasMeter
      @dateTime = dateTime
      @user_id = user_id
      @gas_meter_id = gas_meter_id
      @month = k

    save: (v) ->
      if @id
        param =
          id: @id
          value: v.value
          created: v.created
        @complete = '変更'
      else
        param =
          user_id: @user_id
          gas_meter_id: @gas_meter_id
          year: @year
          month: @month
          value: v.value
        @complete = '変更'
      api = new ApiClient()
      data = await api.post('/admin/collect/save', param)
      if data.errors.length == 0
        @showPopup('complete')
        @getCollect(@year)
        @closePopup('edit')
    returnDateTime: (date) ->
      if date
        return date.replace(/^.{5}/, '')
      return ''
    getCollect: (year) ->
      api = new ApiClient()
      data = await api.get('/admin/collect/list/' + year)
      @gasMeterList = data.list.gasMeter
      @collectList = data.list.collect
  }
